import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AlertBox = ({content}) => {
    const {id, msg, alertType} = content;
    if (alertType==="success") {
        toast.success(msg);
    } else {
        toast.error(msg);
    }
    return (
        <ToastContainer
            key={id}
            position="top-right"
            autoClose={5250}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            limit={1}
        />
    );
}

export default AlertBox;